export default "__VITE_ASSET__B4TykY1v__"